import { useEffect, useRef } from 'react';

const useReadOnlyPlaceholder = (readonlyPlaceholder: string, enabled = true) => {
    const ref = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (ref.current?.hasAttribute('readonly')) {
            if (enabled) {
                ref.current.setAttribute('placeholder', readonlyPlaceholder);
            } else {
                ref.current.removeAttribute('placeholder');
            }
        }
    }, [enabled]);

    return ref;
};

export { useReadOnlyPlaceholder };
